import { useEffect, useState } from 'react';
import type { ViewId } from '@ox/schema';
import { useEditorStore } from '../store/editor-store';
import { IconClose } from './Icons';

export function PreviewModal({
  urls,
  loading = false,
  onClose,
}: {
  urls: Partial<Record<ViewId, string>>;
  loading?: boolean;
  onClose: () => void;
}) {
  const model = useEditorStore((s) => s.model);
  const activeView = useEditorStore((s) => s.activeView);
  const [view, setView] = useState<ViewId>(activeView);

  useEffect(() => {
    setView(activeView);
  }, [activeView]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!model) return null;

  const mainUrl = urls[view];
  const views = model.views;

  return (
    <div className="ox-modal-backdrop ox-ver-backdrop" onClick={onClose}>
      <button type="button" className="ox-ver-close" onClick={onClose} aria-label="Cerrar">
        <IconClose size={20} />
      </button>
      <div
        className="ox-ver-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Vista previa"
      >
        <div className="ox-ver-layout">
          <nav className="ox-ver-thumbs" aria-label="Vistas">
            {views.map((v) => {
              const src = urls[v.id];
              return (
                <button
                  key={v.id}
                  type="button"
                  className={view === v.id ? 'active' : ''}
                  onClick={() => setView(v.id)}
                >
                  {src ? (
                    <img src={src} alt={v.label} />
                  ) : (
                    <div className="ox-ver-thumb-skel" />
                  )}
                  <span>{v.label}</span>
                </button>
              );
            })}
          </nav>
          <div className="ox-ver-main">
            {mainUrl ? (
              <img
                key={mainUrl}
                src={mainUrl}
                alt={views.find((v) => v.id === view)?.label ?? 'Vista previa'}
              />
            ) : loading ? (
              <>
                <div className="ox-ver-main-skel" />
                <p className="ox-ver-loading">Generando vista previa…</p>
              </>
            ) : (
              <p className="ox-ver-loading">Sin vista previa</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
